import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromActivateTrialLicense from './reducers/activate-trial-license.reducer';
import {EffectsModule} from '@ngrx/effects';
import {ActivateTrialLicenseEffects} from './effects/activate-trial-license.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('activateTrialLicense', fromActivateTrialLicense.reducer),
    EffectsModule.forFeature([ActivateTrialLicenseEffects])
  ]
})
export class ActivateTrialLicenseModule { }
